import * as Yup from 'yup';
import moment from 'moment';
import editarArea from './editarAreaFormModel';
const {
  formField: {
    // DATOS CLIENTE
    e_name,
    e_description,
    e_sucursal,
  },
} = editarArea;

export default [
  // INFORMACION BASICA
  Yup.object().shape({
    [e_name.name]: Yup.string().required(`${e_name.requiredErrorMsg}`),
    [e_description.name]: Yup.string().required(`${e_description.requiredErrorMsg}`),
    [e_sucursal.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${e_sucursal.requiredErrorMsg}`),
  }),
];
